import { render, staticRenderFns } from "./NewDealBu.vue?vue&type=template&id=1a2566d2&scoped=true"
import script from "./NewDealBu.vue?vue&type=script&lang=js"
export * from "./NewDealBu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2566d2",
  null
  
)

export default component.exports